/**
 * @file input module
 * @author
 * title: string，名称
 * isMsgRequired: boolean，是否必填项
 * validCode：function，校验规则
 */
import React from 'react';

import LabelFormItem from '../LabelFormItem/index';
import Input from 'antd/lib/input';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';
import './index.less';

interface Props {
    type: string;
    title: string;
    isMsgRequired: boolean;
    data: any;
    updateData?: any;
    style: {};
    placeholder?:string;
    disabled?: boolean;
    onChange?:any;
    onBlur?:any;
}

export default function InputFormItem(props: Props) {
    const {
        type,
        disabled,
        title,
        isMsgRequired,
        data,
        updateData,
        placeholder,
        onChange,
        onBlur,
        style
    } = props;

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateData && updateData({
            [type]: e.target.value,
            [type + 'Err']: ''
        });
        onChange && onChange(e);
    };

    const onInputBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateData && updateData({
            [type]: e.target.value,
            [type + 'Err']: ''
        });
        onBlur && onBlur(e);
    };

    return (
        <div className={'form-item-input'}>
            {title && <LabelFormItem isMsgRequired={isMsgRequired} title={title} />}
            <div className={'form-item-input-box'}>
                <Input
                    className={
                        data[type + 'Err']
                            ? 'form-item-input-content border-error'
                            : 'form-item-input-content'
                    }
                    style={style}
                    value={data[type]}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={onInputChange}
                    onBlur={onInputBlur}
                />
                {data[type + 'Err'] && <p className="form-item-input-err">
                    <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                    {data[type + 'Err']}</p>}
            </div>

        </div>
    );
}
